import { Button } from 'components/ui/button';
import { BotMessageSquare } from 'lucide-react';
import { WalkthroughIds } from 'modules/walkthrough/utils';
import React from 'react';

interface Props {
  toggle: () => void;
}

/**
 * @description Floating action card for collapsed ThreadsBot, clicking will
 * expand the full UI.
 */
const ThreadsBotCollapsedFloatingCard: React.FC<Props> = ({ toggle }) => {
  return (
    <Button variant="ghost" size="icon" onClick={toggle} id={WalkthroughIds.ThreadsBot}>
      <BotMessageSquare color="white" size={26} />
    </Button>
  );
};

export default ThreadsBotCollapsedFloatingCard;
